import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Avatar from '@components/@core/Avatar';

const Detail = ({ user, title, description }) => {
    const navigate = useNavigate();

    return (
        <div className="career-user">
            <div className="header">
                <span className="dsl-b22 bold">{user.name}</span>
            </div>
            <div className="career-user-content">
                <div className="avatar-container">
                    <Avatar name={user.name} url={user.profile.avatar} size="large" onToggle={() => navigate(`/library/record-employee-info/${user.id}`)} />
                </div>
                <div className="d-flex-1 ps-4">
                    <p className="dsl-b18 bold truncate-one">{title}</p>
                    <p className="dsl-b16">{description}</p>
                </div>
            </div>
        </div>
    );
};

Detail.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string,
        profile: PropTypes.shape({
            avatar: PropTypes.string,
        }),
    }),
    title: PropTypes.string,
    description: PropTypes.string,
};

Detail.defaultProps = {
    user: {
        name: '',
        profile: {
            avatar: '',
        },
    },
    programs: '',
    description: '',
};

export default memo(Detail);
